// extracted by mini-css-extract-plugin
export default {"container":"Wfa-z","heading":"Xfa-z","links":"Yfa-z","linkBtn":"Zfa-z","disabled":"_fa-z","linkUppercaseBold":"aga-z","copy":"bga-z","subCopy":"cga-z"};